import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VenueQuoteModel } from './venue-quote.model';

@Injectable({
  providedIn: 'root',
})
export class VenueQuoteService extends AbstractEntityService<VenueQuoteModel> {
  constructor(http: HttpClient) {
    super('/api/venue-quotes', http);
  }

  // TVG-139: download every stored quote as a CSV (gated behind the
  // "quote-export" feature toggle on the backend).
  exportCsv(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}${this.basePath}/export`, {
      responseType: 'blob',
    });
  }
}
